import dev from '../services/dev';
import http from '../services/http';

const urlPrefix = `https://${dev}api.11visa.com/h5`;

export default {
  // 格式化日期
  formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        `${date.getFullYear()}`.substr(4 - RegExp.$1.length),
      );
    }
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
    };

    /* eslint-disable no-restricted-syntax */
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        const str = `${o[k]}`;
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : `00${str}`.substr(str.length),
        );
      }
    }
    return fmt;
  },

  // 删除答案
  qaAnswerDelete(answerId) {
    return http.post(`${urlPrefix}/qa_answer_delete`, {
      qa_answer_id: answerId,
    });
  },

  // 答问举报原因查询
  qaAnswerReportReasonQuery() {
    return http.post(`${urlPrefix}/qa_answer_report_reason_query`, {});
  },

  // 举报答案
  qaAnswerReport(answerId, reason, userAccountId) {
    return http.post(`${urlPrefix}/qa_answer_report`, {
      qa_answer_id: answerId,
      reason_id_set: reason,
      user_account_id: userAccountId,
    });
  },

  // 关注问题
  qaQuestionWatch(params) {
    return http.post(`${urlPrefix}/qa_question_watch`, params);
  },

  // 点赞
  qaAnswerLike(params) {
    return http.post(`${urlPrefix}/qa_answer_like`, params);
  },

  // 获取问答详情
  getQADetail({
    id,
    visa_country_id: visaCountryId,
    user_account_id: userAccountId,
  }) {
    const params = {
      id,
      visa_country_id: visaCountryId || undefined,
      user_account_id: userAccountId || undefined,
    };
    return http.post(`${urlPrefix}/qa_question_query`, params);
  },

  // 获取问题回答
  getQAAnswer(questionId, accountId, page) {
    const params = {
      qa_question_id: questionId,
      user_account_id: accountId || undefined,
      page,
    };
    return http.post(`${urlPrefix}/qa_answer_query`, params);
  },
};
